import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [clickable, setClickable] = useState(false);
  const [faqs, setFaqs] = useState([
    {
      question: "faq_services_free_q",
      answer: "faq_services_free_a"
    },
    {
      question: "faq_anonymous_q",
      answer: "faq_anonymous_a"
    },
    {
      question: "faq_about_q",
      answer: "faq_about_a"
    },
    {
      question: "faq_contribute_q",
      answer: "faq_contribute_a",
      link: `/addsalary/`
    },
    {
      question: "faq_provide_q",
      answer: "faq_provide_a"
    },
    {
      question: "faq_request_q",
      answer: "faq_request_a",
      link: `/explore/`
    },
    {
      question: "faq_updated_q",
      answer: "faq_updated_a"
    },
    {
      question: "faq_account_q",
      answer: "faq_account_a"
    },
    {
      question: "faq_premium_q",
      answer: "faq_premium_a"
    },
    
    // Add more FAQs here
  ]);

  const toggleOpen = (index) => {
    setClickable(false);
    setFaqs(prevFaqs =>
      prevFaqs.map((faq, i) =>
        i === index ? { ...faq, isOpen: !faq.isOpen } : { ...faq, isOpen: false }
      )
    )
    setTimeout(setClickable(false), 20000);
  };

  return (
    <FAQContainer>
      <h1 style={{ textAlign: 'center', margin: '40px 0' }}>{t('FAQs')}</h1>
      {faqs.map((faq, index) => (
        <FAQItem key={index}>
          <FAQQuestion onMouseUp={() => toggleOpen(index)}>
            <h3>{t(faq.question)}</h3>
            <span>{faq.isOpen ? '-' : '+'}</span>
          </FAQQuestion>
          {faq.isOpen && <FAQAnswer href={faq.link}>{t(faq.answer)}</FAQAnswer>}
        </FAQItem>
      ))}
    </FAQContainer>
  );
};

export default FAQ;

const FAQContainer = styled.div`
width:75%;
margin: 0 auto;
color: #333;
margin-bottom: 50px;
`;

const FAQItem = styled.div`
margin-bottom: 20px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
overflow: hidden;
`;

const FAQQuestion = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding: 16px;
gap:25px;
background-color: #f8f9fa;
cursor: pointer;
transition: background-color 0.3s ease;

&:hover {
  background-color: #e9ecef;
}

h3 {
  margin: 0;
  font-size: 18px;
}

span {
  font-size: 24px;
}
`;

const FAQAnswer = styled.a`
display:flex;
color:black;
padding: 16px;
background-color: #f8f9fa;
font-size: 16px;
line-height: 1.6;
width:90%;
margin-top:16px;
`;